import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled, { css, withTheme } from 'styled-components';

import { Media } from '@g4/boneyard/lib/Media';
import Text from '@g4/boneyard/lib/Text';
// TODO: just as a quick fix for old boneyard hosted components
import oldTheme from '../Colors';

const headings = {
  // XS screens and up
  xs: {
    xs: 10,
    sm: 12,
    md: 14,
    lg: 16,
    xl: 20,
    xxl: 30,
  },
  // LG screens and up
  lg: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 24,
    xxl: 40,
  },
};

export class Heading extends PureComponent {
  static propTypes = {
    /** Associates a specific action onto an element for the benefit of automated clients consuming it */
    automationHook: PropTypes.string,
    /** Type of heading */
    headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
    /** Text color */
    color: PropTypes.string,
    /** Font size */
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']).isRequired,
    /** Makes the heading more prominent */
    bold: PropTypes.bool,
    /** Applies a specified font-weight */
    weight: PropTypes.oneOf([100, 400, 700, 900]),
    theme: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    bold: true,
  };

  constructor(props) {
    super(props);

    this.getResponsiveSize = this.getResponsiveSize.bind(this);
  }

  // Similar to ResponsiveComponent->getResponsiveSize
  getResponsiveSize(mq) {
    const { query } = this.props.theme;

    // TODO: quick fix for theme headings until they are implemented in boneyard

    const queries = Object.keys(query);
    const availableSizes = Object.keys(headings);

    if (mq) {
      for (let i = queries.length - 1; i >= 0; i--) {
        const queryKey = queries[i];
        if (availableSizes.includes(queryKey) && mq.gte(queryKey)) {
          return queryKey;
        }
      }
    }

    return 'xs';
  }

  render() {
    // const { headings } = this.props.theme;
    const heading = `h${this.props.headingLevel}`;

    return (
      <Media>
        {mq => {
          const responsiveSize = this.getResponsiveSize(mq);
          const size = headings[responsiveSize][this.props.size];

          return React.createElement(
            heading,
            {
              className: this.props.className,
            },
            <Text
              weight={this.props.weight}
              size={size}
              bold={this.props.bold}
              automationHook={this.props.automationHook}
            >
              {this.props.children}
            </Text>
          );
        }}
      </Media>
    );
  }
}

/** @component */
export default styled(withTheme(Heading))`
  color: ${props => oldTheme.colors.modern.heading.color};

  /** Override the heading color with the provided one by props */
  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `};
`;
